<template lang="pug">
  el-dialog(v-dialog-drag title="字段权限"
    modal-append-to-body append-to-body
    width="1000px"
    :visible.sync="show",
    :close-on-click-modal="false",
    @close="closeHandler" )
    .content
      el-table(:data="tableData" border)
        el-table-column(prop="fieldName" label="字段")
        el-table-column(prop="isHidden" label="隐藏")
        el-table-column(prop="isReadOnly" label="仅查看")
        el-table-column(prop="isEdit" label="可编辑")

    template(#footer)
      div
        .right
          el-button( size="small" @click="close" ) 取消
          el-button(type="primary" size="small" @click="confirmHandler" ) 确定
</template>

<script>
export default {
  name: 'AuthGroupFieldMaintain',
  props: {},
  data () {
    return {
      show: false,
      tableData: [
        {
          fieldId: "3544509647486976",
          fieldName: "主键",
          isHidden: 0,
          isReadOnly: 1,
          isEdit: 0
        },
        {
          fieldId: "3544509995614208",
          fieldName: "状态ID",
          isHidden: 0,
          isReadOnly: 1,
          isEdit: 0
        },
        {
          fieldId: "3544510297604096",
          fieldName: "状态名称",
          isHidden: 0,
          isReadOnly: 1,
          isEdit: 0
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created () {},
  methods: {
    open (editData = null) {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    confirmHandler() {

    },
    resetData () {

    },
    closeHandler () {
      this.resetData();
    }
  }
};
</script>

<style scoped lang="scss">

</style>
